function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{stroke:#20b9b5;stroke-linecap:round;stroke-linejoin:round;stroke-width:10px;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-351.217 -90)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(351.217 90)"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M433.444-939.619",
  transform: "translate(-432.095 955.35)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M432-928.419a.891.891,0,0,1-.631-.261l-2.664-2.664a.893.893,0,0,1,0-1.263.893.893,0,0,1,1.263,0l2.664,2.664a.893.893,0,0,1,0,1.263A.89.89,0,0,1,432-928.419Z",
  transform: "translate(-427.988 949.805)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M435.341-955.9a.891.891,0,0,1-.634-.264l-8.561-8.637a.893.893,0,0,1,.006-1.263.892.892,0,0,1,1.263.006l8.561,8.637a.893.893,0,0,1-.006,1.263A.89.89,0,0,1,435.341-955.9Z",
  transform: "translate(-425.887 977.281)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M440.853-980.9a.89.89,0,0,1-.631-.261l-14.073-14.073a.893.893,0,0,1,0-1.262.893.893,0,0,1,1.263,0l14.073,14.073a.893.893,0,0,1,0,1.263A.89.89,0,0,1,440.853-980.9Z",
  transform: "translate(-425.887 1002.286)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M447.576-1004.844a.892.892,0,0,1-.631-.261l-19.279-19.279a.893.893,0,0,1,0-1.263.893.893,0,0,1,1.263,0l19.279,19.279a.893.893,0,0,1,0,1.263A.891.891,0,0,1,447.576-1004.844Z",
  transform: "translate(-427.133 1026.231)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M471.287-1011.8a.891.891,0,0,1-.631-.261l-14.124-14.124a.893.893,0,0,1,0-1.263.893.893,0,0,1,1.263,0l14.124,14.124a.893.893,0,0,1,0,1.263A.891.891,0,0,1,471.287-1011.8Z",
  transform: "translate(-450.844 1027.71)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M496.663-1016.943a.89.89,0,0,1-.629-.259l-9.06-8.98a.893.893,0,0,1-.006-1.263.893.893,0,0,1,1.263-.005l9.059,8.98a.893.893,0,0,1,.006,1.262A.89.89,0,0,1,496.663-1016.943Z",
  transform: "translate(-475.85 1027.709)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M522.664-1021.756a.89.89,0,0,1-.631-.261l-3.407-3.407a.893.893,0,0,1,0-1.263.893.893,0,0,1,1.263,0l3.407,3.407a.893.893,0,0,1,0,1.263A.89.89,0,0,1,522.664-1021.756Z",
  transform: "translate(-501.85 1027.085)"
})));

var SvgBackground = function SvgBackground(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21.707,
    height: 21.386,
    viewBox: "0 0 21.707 21.386",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBackground, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/background.006730b1.svg";
export { ForwardRef as ReactComponent };